
export default function EditButtonDirective() {
    'ngInject';
    return {
        template: require('./edit-button.html'),
        restrict: 'E',
        scope: {
            editing: '=',
            editMode: '=',
        },
        controller: ['$scope', function ($scope) {

            if ($scope.editMode) {
                $scope.toggle = function () {
                    $scope.editing = !$scope.editing;
                };
            }
        }]
    };
}
